import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { TrendingUp, Clock, DollarSign, ArrowRight } from 'lucide-react';

const CaseStudies = () => {
  const caseStudies = [
    {
      company: 'ABC Manufacturing',
      industry: 'Manufacturing',
      challenge: 'Manual tracking causing 20% inventory discrepancies',
      solution: 'Implemented WMS with RFID tracking',
      results: [
        { icon: <TrendingUp className="w-5 h-5" />, metric: '95%', label: 'Accuracy Improvement' },
        { icon: <Clock className="w-5 h-5" />, metric: '50%', label: 'Time Saved' },
        { icon: <DollarSign className="w-5 h-5" />, metric: '₹2.5M', label: 'Annual Savings' }
      ],
      color: 'blue'
    },
    {
      company: 'RetailPro India',
      industry: 'Retail',
      challenge: 'Stockouts and overstock issues across 50+ stores',
      solution: 'Real-time inventory tracking with mobile app integration',
      results: [
        { icon: <TrendingUp className="w-5 h-5" />, metric: '75%', label: 'Stockout Reduction' },
        { icon: <Clock className="w-5 h-5" />, metric: '40%', label: 'Faster Replenishment' },
        { icon: <DollarSign className="w-5 h-5" />, metric: '₹5M', label: 'Revenue Increase' }
      ],
      color: 'cyan'
    },
    {
      company: 'MediCare Supplies',
      industry: 'Healthcare',
      challenge: 'Compliance issues and expired medication tracking',
      solution: 'IoT-enabled asset tracking with automated alerts',
      results: [
        { icon: <TrendingUp className="w-5 h-5" />, metric: '100%', label: 'Compliance Rate' },
        { icon: <Clock className="w-5 h-5" />, metric: '60%', label: 'Audit Time Reduced' },
        { icon: <DollarSign className="w-5 h-5" />, metric: '₹1.8M', label: 'Waste Reduction' }
      ],
      color: 'blue'
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">Success Stories</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">Real results from real businesses across industries</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {caseStudies.map((study, index) => (
            <Card key={index} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 group">
              <CardHeader>
                <div className={`inline-block px-3 py-1 rounded-full text-sm font-semibold mb-3 bg-${study.color}-100 text-${study.color}-600`}>
                  {study.industry}
                </div>
                <CardTitle className="text-2xl mb-2 group-hover:text-blue-600 transition-colors">{study.company}</CardTitle>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm font-semibold text-slate-500 uppercase">Challenge</p>
                    <p className="text-slate-700">{study.challenge}</p>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-slate-500 uppercase">Solution</p>
                    <p className="text-slate-700">{study.solution}</p>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm font-semibold text-slate-500 uppercase mb-4">Results</p>
                <div className="space-y-4">
                  {study.results.map((result, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <div className={`p-2 rounded-lg bg-${study.color}-100 text-${study.color}-600`}>
                        {result.icon}
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-slate-900">{result.metric}</div>
                        <div className="text-sm text-slate-600">{result.label}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/contact">
            <Button size="lg" className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white px-8 py-6 text-lg transition-all duration-300 hover:scale-105">
              Start Your Success Story <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;